/**
 * @file Extends the address schema with Dwolla's stricter field limits.
 */

import extendSchema from "@api/helpers/extendSchema";

import type { AddressInput } from "./types";

const DWOLLA_STREET_MAX_LENGTH = 100;

/**
 * Extends the address schema with Dwolla's longer street address limit.
 */
const getDwollaAddressSchema = (addressSchema: AddressInput[]): AddressInput[] => {
  const newInputs = extendSchema(addressSchema, [
    {
      name: "streetAddress",
      maxLength: DWOLLA_STREET_MAX_LENGTH,
    },
  ]);

  return newInputs;
};

export default getDwollaAddressSchema;
